import {SearchProvider} from "@buildwithflux/constants";

/**
 * Generating the And operator for a search, taking searchProvider
 * into account
 */
export function normalizedAndOperator(searchProvider: SearchProvider) {
    return searchProvider === "typesense" ? "&&" : "AND";
}
